import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Table, Button} from "reactstrap";
import {GetFormValue3Tiers, SyncDelete} from 'datasync-core'
import {useSelector, useDispatch } from 'react-redux';
import {deleteArticle, revertStatusArticles} from "../../redux/articleSlice";
import {openModalArticle} from "../../redux/modalSlice";
import {openModalStat, openModal} from "../../redux/modalSlice";
import {globals} from "../Globals/Globals"
import Article from "../Article/Article";

const ArticlesRawTableDataSync = (props) =>{
    const {deleteArticle_result} = useSelector((state) => state.articles)
    const dispatch = useDispatch();

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        if (deleteArticle_result.status == "deleted"){
            try{
                dispatch(openModal({title:"Article supprimé"}));
            }
            finally{
                dispatch(revertStatusArticles())
            }
        }

        // Cleanup function
        return () => {
            isMounted = false;
        }
    }, [dispatch, deleteArticle_result]);

     /**
     * 
     * @param {*} this 
     * @param {*} handleManager 
     * @param {*} userItem 
     * @param {*} data_guid 
     */
    const handleManager = async (p_s_item_key, p_callback_handler) => {
        try {
            if (globals.parameters.debugging) console.log("handleManager::p_s_item_key =>", p_s_item_key)
                p_callback_handler(props.article_list.find((item) => item.data_guid == p_s_item_key))
        } catch (error) {
            alert(`handleManager for ${p_callback_handler} raise error ${error.message}`)
        }
    }
    

    const tableRendering = () => {
        let table_body = null;

        if (!((props.article_list != null) && (props.article_list.length > 0))){
            table_body = <tr><td colSpan="4">Pas d'article disponible</td></tr>;
        }
        else{
            table_body = props.article_list.map((articleItem,i)=>{
                return  <tr key={articleItem.data_guid} className="thumbnail">
                            <td id="table-item-container">
                                <div id="table-item">
                                    <Article
                                        key={articleItem.data_guid}
                                        title={articleItem.data_blob.data_tier.article_title}
                                        text={articleItem.data_blob.data_tier.article_text}
                                        pictureURL={articleItem.data_blob.data_tier.article_photo}
                                        article_link={articleItem.data_blob.data_tier.article_link}
                                    />
                                </div>
                                <div id="table-commands">
                                    {!props.read_only &&
                                        <div className="cmd_btn_delete">
                                            <Button onClick={()=>{handleManager(articleItem.data_guid, (articleObject)=>{
                                                dispatch(openModal(
                                                                    {title:`Supprimer l'article ${articleObject.data_blob.data_tier.article_title} ?`,
                                                                        okCallBack:(DialogObject)=>{dispatch(deleteArticle(articleObject))}})) })}}
                                            style={{cursor:"pointer"}}>Effacer</Button>
                                        </div>}
                                    
                                    {!props.read_only &&
                                        <div className="cmd_btn_update">
                                            <Button onClick={()=>{handleManager(articleItem.data_guid, (articleObject)=>{dispatch(openModalArticle({article_data_guid:articleObject, read_only:false}))})}} 
                                            style={{cursor:"pointer"}}>Modifier</Button>
                                        </div>}
                                </div>
                            </td>
                        </tr>});
                }

        return(
            <Table striped responsive={true}>
               <tbody>
                    {table_body}
                </tbody>
            </Table>
            );
    }

    return (
        <>
            {tableRendering()}
        </>);
}

ArticlesRawTableDataSync.propTypes = { 
    table: PropTypes.bool,
};

ArticlesRawTableDataSync.defaultProps = {
    table:true,
};



export default ArticlesRawTableDataSync;
